import React from "react";

import { history } from "@helpers/history";

import ButtonArrow from "@areas/shared/components/buttons/ButtonArrow";
import Honeycombs from "@areas/shared/components/background/Honeycombs";
import TextFilter from "@areas/shared/components/text/TextFilter";
import Helper from "@areas/shared/components/helper/Helper";
import Chooser from "@areas/schoolboy/components/choose/Chooser";

import btnStyles from "@areas/schoolboy/components/buttons/styles/button.module.css";
import styles from "./styles/about.module.css";

function About(props) {
  return (
    <div className={styles.block}>
      <Honeycombs style={styles.background} filter="#6E9A10" />
      <div className={`container ${styles.content}`}>
        <div>
          <div className={styles.info}>
            <TextFilter
              customStyles={{
                all: styles.header,
                text: styles.text,
                filter: styles.filter,
              }}
            >
              <p className={styles.first}>Команда</p>
              <p className={styles.second}>будущего</p>
            </TextFilter>
            <TextFilter
              customStyles={{
                all: styles.header,
                text: styles.text,
                filter: styles.filter,
              }}
            >
              Школьники
            </TextFilter>
            <div className={styles.subheader}>
              Школьники и будущие абитуриенты могут найти полезные материалы по профориентации, с
              легкостью выбрать специальность и учебное заведение в Республике
              Башкортостан
            </div>
            <ButtonArrow
              customStyles={{
                main: styles.more,
                border: styles.border,
                arrow: styles.arrow,
                fill: styles.fill,
              }}
              onClick={() => history.navigate(`/about`)}
            >
              Подробнее о нас
            </ButtonArrow>
          </div>
        </div>
        <Helper
          cardStyles={{
            main: styles.card,
            border: styles.border,
            arrow: styles.arrow,
            message: styles.message,
          }}
          buttonStyle={`${btnStyles.button} ${btnStyles.secondary}`}
          filterBackground="#6E9A10"
          filename="helper-schoolboy.json"
        />
      </div>
      <Chooser
        gradientId="chooserBackground"
        gradientSteps={[
          {
            offset: 0,
            stopColor: "#CBEC00",
          },
          {
            offset: 0.55,
            stopColor: "#6E9A10",
          },
          {
            offset: 1,
            stopColor: "#D0A024",
          },
        ]}      
        he={650}
      />
    </div>
  );
}

export default About;
